import type { PriceReportSelection } from "../../api/priceReport";

export function lastFullMonth(now = new Date()): { from: string; to: string } {
  return {
    from: localDate(new Date(now.getFullYear(), now.getMonth() - 1, 1)),
    to: localDate(new Date(now.getFullYear(), now.getMonth(), 0)),
  };
}

function localDate(value: Date): string {
  return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`;
}

export function reportSelection(params: URLSearchParams): PriceReportSelection {
  const defaultDates = lastFullMonth();
  return {
    period: !params.has("cost_center") && (params.get("period") === "last_month" || (!params.has("from") && !params.has("to"))) ? "last_month" : "custom",
    from: params.get("from") ?? (params.has("cost_center") ? "" : defaultDates.from),
    to: params.get("to") ?? (params.has("cost_center") ? "" : defaultDates.to),
    costCenter: params.get("cost_center") ?? undefined,
    costCenterType: params.get("cost_center_type") ?? undefined,
    returnTo: safeCostCenterReturn(params.get("return_to")),
    supplier: params.get("supplier") ?? "",
    project: params.get("project") ?? "",
    threshold: params.has("min_delta_pct") ? Number(params.get("min_delta_pct")) : 15,
    difference: params.has("min_difference") ? Number(params.get("min_difference")) : 0,
  };
}

export function selectionError(selection: PriceReportSelection): string | null {
  if (!!selection.costCenter !== !!selection.costCenterType || (selection.costCenterType && !["project", "delivery_address", "customer_reference", "order_context"].includes(selection.costCenterType)) || (selection.costCenter && selection.project)) return "Die Kostenstellenauswahl im Link ist ungültig.";
  const dates = [selection.from, selection.to].filter(value => value || !selection.costCenter);
  if (dates.some(value => !/^\d{4}-\d{2}-\d{2}$/.test(value) || !Number.isFinite(Date.parse(value)) || new Date(value).toISOString().slice(0, 10) !== value)) {
    return "Bitte wähle einen gültigen Zeitraum.";
  }
  if (selection.from && selection.to && selection.from > selection.to) return "Das Enddatum muss am oder nach dem Startdatum liegen.";
  if (!Number.isFinite(selection.threshold) || selection.threshold < 0 || selection.threshold > 1000000 || !Number.isFinite(selection.difference) || selection.difference < 0 || selection.difference > 1000000000) {
    return "Bitte gib gültige, nicht negative Schwellen für diesen Bericht ein.";
  }
  return null;
}

export const reportButton = "inline-flex h-9 items-center justify-center gap-2 rounded-md border border-slate-300 bg-white px-3 text-sm font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-50";
export const reportPrimary = "inline-flex h-9 items-center justify-center gap-2 rounded-md bg-emerald-600 px-3 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-50";


export function safeCostCenterReturn(value: string | null): string | undefined {
  if (!value?.startsWith("/cost-centers/detail/") || value.includes("\\")) return undefined;
  return value;
}
